import { render, staticRenderFns } from "./FieldApproval.vue?vue&type=template&id=d97fa478&scoped=true&"
import script from "./FieldApproval.vue?vue&type=script&lang=js&"
export * from "./FieldApproval.vue?vue&type=script&lang=js&"
import style0 from "./FieldApproval.vue?vue&type=style&index=0&id=d97fa478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97fa478",
  null
  
)

export default component.exports